<template>
  <div class="one-column-width">
    <!-- show action result -->
    <v-snackbar v-model="snackbar" absolute top right color="success">
      <span>{{ snackBarText }}</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <v-snackbar v-model="errorMessage" absolute top right color="danger">
      <span>Something went RONG, Please Try Again!</span>
      <v-icon dark>mdi-checkbox-marked-circle</v-icon>
    </v-snackbar>

    <!-- Confirm Delete Item -->

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline">Do you really want to DELETE this item?</span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false">No</v-btn>
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner>Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <div class="row">

      <div class="col-lg-8">
        <!-- table start -->
          <v-card class="r_tabsform_card">
            <v-card-title class="r_form_card_title">
              Second Level Categories
              
              <!-- <div class="my-2 ml-2">
                <v-btn
                  class="btn btn-sm btn-success font-weight-bold py-2 px-3 px-xxl-5 my-1"
                  fab
                  small
                  @click="showForm"
                >
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </div> -->
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                class="r_form_top_search"
                append-icon="search"
                label="Search second level categories"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <hr class="r_form_card_top_hr">

            <v-data-table class="r_admn_dashboad_tdss" :headers="headers" :items="tableData" :search="search" loading>
              <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    class="btn btn-sm btn-light font-weight-bold py-3 px-3 px-xxl-5 my-1 "
                    fab
                    small
                    @click="showEditForm(item)"
                  >
                    <v-icon class="text-success">fas fa-edit fa-lg</v-icon>
                  </v-btn>
                  &nbsp;
                  <v-btn
                    class="btn btn-sm btn-light font-weight-bold py-3 px-3 px-xxl-5 my-1"
                    fab
                    small
                    @click="askUserAboutDelete(item)"
                  >
                    <v-icon class="text-danger">mdi-delete</v-icon>
                  </v-btn>
              </template>
            </v-data-table>
            <div class="r_form_add_more_btnnn_div">
              <button @click="showForm" class="r_form_add_more_btnnn">Add new second level category</button>
            </div>
          </v-card>

        <!-- table end -->
      </div>



      <div class="col-lg-4">
        <!-- form start -->
          <v-card class="r_tabsform_card" v-if="showFormData">
            <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Add New Second Level Category </v-card-title>
            <hr class="r_form_card_top_hr">
            
            <div>
              <v-form ref="form" @submit.prevent="submit" class="">
                <v-container fluid>
                  <v-col cols="12">
                    <v-row v-for="(item, index) in form" :key="index">
                      <v-autocomplete
                        v-model="item.first_level_categories_id"
                        :rules="rules.first_level_categories_id"
                        :items="categoriesData"
                        label="Select Parent Category"
                        class="r_formtabs_inputs col-7"
                      ></v-autocomplete>
                      <input
                        v-model="item.category"
                        :rules="rules.level"
                        color="purple name-2"
                        label="Level Name"
                        class="r_formtabs_inputs col-7"
                        required
                      >
                      <template v-if="!editId">
                        <button
                          class="r_form_add_more_recods_btnnn col-2"
                          type="button"
                          @click="addNewRow()"
                          >Add</button
                        >
                        <button
                          v-if="index > 0"
                          class="r_cust_del_new_rec_btn col-2"
                          type="button"
                          @click="deleteRow(index)"
                          >Delete</button
                        >
                      </template>
                    </v-row>
                  </v-col>
                </v-container>
                <v-card-actions>
                  <button
                    :disabled="$v.$invalid || submitting"
                    class="r_form_add_more_btnnn"
                    type="submit"
                    ><b-spinner small type="grow" v-if="submitting"></b-spinner>
                    <span v-if="!editId">Submit</span>
                    <span v-if="editId">Update</span>
                  </button>
                  <button text @click="cancelForm" class="r_form_cancel_more_btnnn">Cancel</button>
                </v-card-actions>
              </v-form>
            </div>
          </v-card>
        <!-- form end -->
      </div>
    </div>
  </div>
</template>

<script>
import CategoryService from "@/MainServices/CategoryService.js";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: [{ category: "", first_level_categories_id: null }],
      categoriesData: [],
      editId: null,
      deleteId: null,
      dialog: false,
      rules: {
        category: [(val) => (val || "").length > 0 || "Category Name is required"],
        first_level_categories_id: [(val) => !!val || "Parent Category is required"],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      headers: [
        {
          text: "First Level",
          align: "left",
          sortable: false,
          value: "first_level.category",
          width: "40%",
          class: "r_admn_dashboad_title"
        },
        {
          text: "Second Level",
          align: "left",
          sortable: false,
          value: "category",
          width: "40%",
          class: "r_admn_dashboad_title"
        },
        { text: "Actions", value: "actions", sortable: false, class: "r_admn_dashboad_title" },
      ],
      tableData: [],
    };
  },
  validations: {
    form: {
      required,
      $each: {
        category: { minLength: minLength(1), required },
        first_level_categories_id: { minLength: minLength(1), required },
      },
    },
  },
  components: {},

  computed: {},

  methods: {
    getInititalData() {
      CategoryService.getSecondLevelCategories()
        .then((res) => {
          this.tableData = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // main methods
    showForm() {
      this.editId = null;
      this.showFormData = true;
      this.resetForm();
    },
    showEditForm(item) {
      this.form = [
        {
          category: item.category,
          first_level_categories_id: item.first_level_categories_id,
        },
      ];
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.resetForm();

      this.showFormData = false;
    },
    resetForm() {
      this.form = [{ category: "", first_level_categories_id: null }];
      this.editId = null;
      setTimeout(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      }, 100);
    },
    addNewRow() {
      this.form.push({ category: "", first_level_categories_id: null });
    },
    deleteRow(index) {
      this.form.splice(index, 1);
    },
    submit() {
      this.submitting = true;
      if (this.editId) {
        CategoryService.editSecondLevelCategory(this.form, this.editId)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Second Level Category Updated successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      } else {
        CategoryService.addNewSecondLevelCategory(this.form)
          .then((res) => {
            this.resetForm();
            this.getInititalData();
            this.submitting = false;
            this.snackBarText = "Second Level Categories Added successful!";
            this.snackbar = true;
          })
          .catch((error) => {
            this.errorMessage = true;
          });
      }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      CategoryService.deleteSecondLevelCategory(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Second Level Category Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    this.getInititalData();
    CategoryService.getFirstLevelCategories()
      .then((res) => {
        res.data.map((el) => {
          this.categoriesData.push({ value: el.id, text: el.category });
        });
      })
      .catch((e) => {});

  },
};
</script>

<style scoped>
.text-success {
    color: #2eca8b !important;
}
.text-danger {
    color: #a82511 !important;
}

</style>
